import React, { useState, useEffect, useMemo } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ServiceImage from "./components/serviceImage/serviceImage";
import ServiceData from "./components/serviceData/serviceData";
import { baseUrl } from "../../../../../../../../../../../network/constants/constants";
import { getConfig } from "../../../../../../../../../../../network/auth";
import axios from "../../../../../../../../../../../network/api";
import './serviceDetailsPage.css';

const ServiceDetailsPage = ({ onGoBack, serviceId }) => {

  const [detailService, setDetailService] = useState([]);
  const [loading, setLoading] = useState(false);


  const config = useMemo(() => {
    return getConfig()
  },[])
  
  const fetchServiceDetailsPage = () => {
    setLoading(true);
    axios
      .get(baseUrl + `superadmin/services-by/${serviceId}/`, config)
      .then((response) => {
        setLoading(false);
        setDetailService(response.data); 
      })
      .catch((error) => {
        console.error("Error fetching service details:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchServiceDetailsPage();
  }, []);

  return (
    <Container fluid>
      <button className="back mb-3" onClick={onGoBack}>
        <ArrowBackIcon />
        Go Back to Service
      </button>
      <Row>
        <Col lg={5}>
        <ServiceData detailService={detailService}/>
        </Col>
        <Col lg={7}>
          <ServiceImage  serviceId={serviceId} />
        </Col>
      </Row>
    </Container>
  );
};

export default ServiceDetailsPage;
